<template>
  <div class="mt-2 flex flex-wrap min-w-0">
    <div v-if="tags.length > 0" class="flex flex-wrap min-w-0 gap-y-2">
      <div v-for="tag in tags" :key="tag.name">
        <div
          v-if="tag.isTag"
          class="box-box min-h-[28px] md:min-h-[32px] lg:min-h-[36px] px-[8px] md:px-[10px] py-[4px] md:py-[6px] mr-2 rounded-[16px] whitespace-nowrap flex items-center justify-center"
          :style="setTagColor(tag.backgroundColor, tag.textColor, hasPast)"
        >
          <p
            class="text-[0.75rem] md:text-[0.875rem] lg:text-[1rem] font-semibold leading-tight md:leading-tight lg:leading-tight text-center px-2"
          >
            {{ tag.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hasPast: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pastClass: 'bg-[#D3D8DE] text-[#7C8A9C]',
    };
  },
  methods: {
    setTagColor(backgroundColor, textColor, hasPast) {
      if (hasPast) {
        return {
          backgroundColor: '#c3c2c1',
          color: '#403f3d',
        };
      } else {
        return {
          backgroundColor: backgroundColor,
          color: textColor,
        };
      }
    },
  },
};
</script>
